import { render } from "./GeneralBio.vue?vue&type=template&id=64ef4a0c"
import script from "./GeneralBio.vue?vue&type=script&lang=js"
export * from "./GeneralBio.vue?vue&type=script&lang=js"

import "./GeneralBio.vue?vue&type=style&index=0&id=64ef4a0c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__